import { WEB_COMPONENT_CLOUD_WORKLOAD_SECURITY_APP } from '../../webcomponents.constants';
import { CloudWorkloadSecurityCustomerViewWebComponent } from './component/CloudWorkloadSecurityCustomerViewWebComponent';

export { CloudWorkloadSecurityCustomerViewWebComponent };

window.customElements.define(WEB_COMPONENT_CLOUD_WORKLOAD_SECURITY_APP, CloudWorkloadSecurityCustomerViewWebComponent);
